import { gql as i } from "@apollo/client";
import { LoginAccountFragment as n } from "../fragment/account.js";
const m = i`
  mutation LoginByEmail($input: LoginByEmailInput!) {
    loginByEmail(input: $input) {
      ...LoginAccount
    }
  }

  ${n}
`;
export {
  m as default
};
//# sourceMappingURL=loginByEmail.js.map
